import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.css']
})
export class BaseComponent implements OnInit {

  onShowPeriod: String = 'today';
  onShowSection: String = 'keynote';
  showDropdownMenu = false;
  onShowMenu: Boolean = false;

  constructor() { }

  ngOnInit() {
  }

  periodUpdated(period: String) {
    this.onShowPeriod = period;
    console.log(period);
  }

  sectionUpdated(section: String) {
    this.onShowSection = section;
    console.log(section);
  }

  toggleMenu(showMenu: Boolean) {
    this.onShowMenu = showMenu;
  }

}



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/base.component.ts